module.exports = __webpack_public_path__ + "img/mounting.21688674.jpg";